/*
 * Page contacts - Liste des contacts avec boutons pour ajouter, éditer, supprimer
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContactData, contactsApi } from '../features/contacts';
import ContactsTable from 'features/contacts/components/ContactsTable';
import { AddButton } from '../common';

// Contacts page component
const Contacts: React.FC = () => {
	// State management
	const [contacts, setContacts] = useState<ContactData[]>([]);
	const [loading, setLoading] = useState(true);
	// Navigation hook
	const navigate = useNavigate();

	// Fetch contacts on component mount
	useEffect(() => {
		// Get token from localStorage
		const token = localStorage.getItem('token');
		// If no token, exit
		if (!token) return;
		contactsApi
			.listPaginated(token, { limit: 999999 })
			.then((res) => setContacts(res.data))
			.catch((error) => console.error(error))
			.finally(() => setLoading(false));
	}, []);

	// Handlers pour l'ajout, l'édition et la suppression
	const handleAdd = () => navigate('/app/contacts/new');
	const handleEdit = (id: number) => navigate(`/app/contacts/${id}/edit`);
	const handleDelete = (id: number) => {
		const token = localStorage.getItem('token');
		if (!token) return;

		contactsApi
			.delete(id, token)
			.then(() => {
				setContacts((prev) => prev.filter((contact) => contact.id !== id));
			})
			.catch((error) => console.error(error));
	};

	// Render the contacts page
	return (
		<div className="min-h-screen bg-gray-100 p-6">
			<div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
				<div className="flex justify-between items-center mb-6">
					<h1 className="text-3xl font-bold">Gestion des contacts</h1>
					<AddButton label="Ajouter un contact" onClick={handleAdd} size="lg" />
				</div>

				{loading ? (
					<p>Chargement des contacts...</p>
				) : (
					<ContactsTable
						contacts={contacts}
						onEdit={handleEdit}
						onDelete={handleDelete}
					/>
					/*<p>Aucune donnée à afficher.</p>*/
				)}
			</div>
		</div>
	);
};
export default Contacts;
